import { selectKeyPath } from '@odc/odbelt'
import React from 'react'
import { ODMultipleFileInput } from './ODMultipleFileInput'
var DEFAULT_RENDER_DROPZONE = function () {
  return React.createElement(
    'div',
    null,
    '\uC774 \uACF3\uC744 \uB450 \uBC88 \uD074\uB9AD\uD558\uAC70\uB098, \uD30C\uC77C\uC744 \uB4DC\uB798\uADF8\uD558\uC5EC \uD30C\uC77C\uC744 \uCD94\uAC00\uD558\uC138\uC694.'
  )
}
var DEFAULT_RENDER_EMPTY = function () {
  return React.createElement(React.Fragment, null)
}
var DEFAULT_RENDER_CONTAINER = function (children) {
  return React.createElement('div', null, children)
}
export var ODSimpleMultipleFileInput = function (props) {
  var accept = props.accept,
    width = props.width,
    height = props.height,
    keyPathToArray = props.keyPathToArray,
    updateKey = props.updateKey,
    _a = props.renderDropzoneChild,
    renderDropzoneChild = _a === void 0 ? DEFAULT_RENDER_DROPZONE : _a,
    renderItem = props.renderItem,
    _b = props.renderContainer,
    renderContainer = _b === void 0 ? DEFAULT_RENDER_CONTAINER : _b,
    _c = props.renderEmpty,
    renderEmpty = _c === void 0 ? DEFAULT_RENDER_EMPTY : _c
  return React.createElement(ODMultipleFileInput, {
    accept: accept,
    width: width,
    height: height,
    name: updateKey,
    keyPath: keyPathToArray,
    renderDropzoneChild: renderDropzoneChild,
    render: function (v, _a) {
      var formikContext = _a.formikContext,
        removeItem = _a.removeItem
      var _b = formikContext || {},
        values = _b.values,
        setFieldValue = _b.setFieldValue
      var array = selectKeyPath(keyPathToArray)(v, [])
      if (array.length === 0) {
        return React.createElement(React.Fragment, null, renderEmpty())
      }
      var items = array.map(function (file, index) {
        // 서버에 업로드된 것을 보여줄 때는 hashId를, 브라우저 파일을 보여줄 때에는 blobUrl 을 키로 사용한다.
        var key = file.hashId || file.blobUrl
        return renderItem(key, file, function () {
          return removeItem(index)
        })
      })
      return renderContainer(items)
    },
  })
}
//# sourceMappingURL=ODSimpleMultipleFileInput.js.map
